import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';

const ScoreCard = () => {
  return (
    <div className="intro-banner why-cdr">
      <Text modifiers="question-title primary-blue">
        <FormattedMessage
          id="Questionnaire.CDR.SubMenuItem.4"
          defaultMessage="Score Card Questions"
        />
      </Text>
      <Text type="normal-bold" modifiers="sub-title">
        <FormattedMessage
          id="Questionnaire.CDR.ScoreCard.SubTitle"
          defaultMessage={`
            Questions 1-3 Score Card - Total of 15 points per indicator
          `}
        />
      </Text>      
      <table className="cdr-table score-card">
        <tbody>
          <tr>
            <td className="question-points">
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.StrategicAbility.Title"
                  defaultMessage="Strategic Ability and Adaptability"
                />
              </Text>
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.Leadership.Title"
                  defaultMessage="Leadership and Governance"
                />
              </Text>
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.Finance.Title"
                  defaultMessage="Financial Health & Organizational Management"
                />
              </Text>              
            </td>
            <td className="explanation-section">
              <table className="cdr-table">
                <thead>
                  <tr>
                    <th style={{borderLeft: 'unset', borderTop: 'unset', width: '180px'}}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.NotEnoughData"
                          defaultMessage="Not Enough Data"
                        />
                      </Text>
                    </th>
                    <th style={{ borderTop: 'unset', width: '80px' }}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.ProblemArea"
                          defaultMessage="Problem Area"
                        />
                      </Text>
                    </th>
                    <th style={{ borderTop: 'unset', width: '80px' }}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.GoodEnough"
                          defaultMessage="Good Enough"
                        />
                      </Text>
                    </th>                    
                    <th style={{ borderRight: 'unset', borderTop: 'unset', width: '150px' }}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.VeryGood"
                          defaultMessage="Very Good"
                        />
                      </Text>
                    </th>
                  </tr>
                </thead>                
                <tbody>
                  <tr>
                    <td style={{ borderLeft: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        0 - 3.74
                      </Text>
                    </td>
                    <td>
                      <Text modifiers="normal__smaller">
                        3.75 - 7.49
                      </Text>
                    </td>
                    <td>
                      <Text modifiers="normal__smaller">
                        7.50 - 11.24
                      </Text>
                    </td>
                    <td style={{ borderRight: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        11.25 - 15
                      </Text>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderLeft: 'unset', borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.NotEnoughData.Explanation"
                          defaultMessage="CSO answered in the negative and/or did not provide enough data."
                        />
                      </Text>
                    </td>
                    <td style={{borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.ProblemArea.Explanation"
                          defaultMessage="CSO is struggling and needs to  take steps to address the challenges."
                        />
                      </Text>
                    </td>
                    <td style={{borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.GoodEnough.Explanation"
                          defaultMessage="CSO has good enough basic capacity to operate but needs strengthen some areas."
                        />
                      </Text>
                    </td>
                    <td style={{ borderRight: 'unset', borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.VeryGood.Explanation"
                          defaultMessage="CSO has high capacity and is  operating without any major difficulties."
                        />
                      </Text>
                    </td>                    
                  </tr>
                </tbody>
              </table>  
            </td>
          </tr>
        </tbody>
      </table>
      <Text type="normal-bold" modifiers="sub-title">
        <FormattedMessage
          id="Questionnaire.CDR.ScoreCard.SubTitle.2"
          defaultMessage={`
            Questions 4-8 Score Card - Total of 11 points per indicator
          `}
        />
      </Text>
      <table className="cdr-table score-card">
        <tbody>
          <tr>
            <td className="question-points">
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.HumanResource.Title"
                  defaultMessage="Human Resources and Staff Development"
                />
              </Text>
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.Communications.Title"
                  defaultMessage="Communications"
                />
              </Text>
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.Monitoring.Title"
                  defaultMessage="Monitoring and Evaluation"
                />
              </Text>
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.Partnerships.Title"
                  defaultMessage="Partnerships and Alliances"
                />
              </Text>
              <Text type="small-bold" modifiers="uppercase">
                <FormattedMessage
                  id="Questionnaire.CDR.EightIndicators.Operations.Title"
                  defaultMessage="Operations"
                />
              </Text>                            
            </td>
            <td className="explanation-section">
              <table className="cdr-table">
                <thead>
                  <tr>
                    <th style={{ borderLeft: 'unset', borderTop: 'unset', width: '180px' }}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.NotEnoughData"
                          defaultMessage="Not Enough Data"
                        />
                      </Text>
                    </th>
                    <th style={{ borderTop: 'unset', width: '80px' }}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.ProblemArea"
                          defaultMessage="Problem Area"
                        />
                      </Text>
                    </th>
                    <th style={{ borderTop: 'unset', width: '80px' }}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.GoodEnough"
                          defaultMessage="Good Enough"
                        />
                      </Text>
                    </th>
                    <th style={{ borderRight: 'unset', borderTop: 'unset', width: '150px' }}>
                      <Text type="explanation" modifiers="uppercase">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.VeryGood"
                          defaultMessage="Very Good"
                        />
                      </Text>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ borderLeft: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        0 - 2.74
                      </Text>
                    </td>
                    <td>
                      <Text modifiers="normal__smaller">
                        2.75 - 5.49
                      </Text>
                    </td>
                    <td>
                      <Text modifiers="normal__smaller">
                        5.50 - 8.24
                      </Text>
                    </td>
                    <td style={{ borderRight: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        8.25 - 11
                      </Text>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderLeft: 'unset', borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.NotEnoughData.Explanation"
                          defaultMessage="CSO answered in the negative and/or did not provide enough data."
                        />
                      </Text>
                    </td>
                    <td style={{ borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.ProblemArea.Explanation"
                          defaultMessage="CSO is struggling and needs to  take steps to address the challenges."
                        />
                      </Text>
                    </td>
                    <td style={{ borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.GoodEnough.Explanation"
                          defaultMessage="CSO has good enough basic capacity to operate but needs strengthen some areas."
                        />
                      </Text>
                    </td>
                    <td style={{ borderRight: 'unset', borderBottom: 'unset' }}>
                      <Text modifiers="normal__smaller">
                        <FormattedMessage
                          id="Questionnaire.CDR.ScoreCard.InnerTable.VeryGood.Explanation"
                          defaultMessage="CSO has high capacity and is  operating without any major difficulties."
                        />
                      </Text>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>            
    </div>
  );
};

export default ScoreCard;


// WEBPACK FOOTER //
// ./src/components/CDRSections/ScoreCard.js